export const trackSummaryStyle = {
  cardContainer: {
    // width: "175px",
    // marginRight: "15px",
    padding: '0px 15px 0px 0px'
    // display: "inline-block",
  },
  allCardSummaryContainer: {
    padding: '0px 30px'
  }
}



// WEBPACK FOOTER //
// ./src/components/Track/styles/TrackSummaryStyle.js